module.exports = __webpack_public_path__ + "static/img/015.6087a0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-eplus/015.png
// module id = X/dz
// module chunks = 1